import { render, staticRenderFns } from "./Point.vue?vue&type=template&id=46adafc0&scoped=true"
import script from "./Point.vue?vue&type=script&lang=js"
export * from "./Point.vue?vue&type=script&lang=js"
import style0 from "./Point.vue?vue&type=style&index=0&id=46adafc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46adafc0",
  null
  
)

export default component.exports